import { useEffect, useState } from "react"
import { Input } from "./Input"
import { PasswordInput } from "./PasswordInput"
import { PrimaryButton } from "../buttons/PrimaryButton"
import Checkbox from "./Checkbox"
import { LinkText } from "../buttons/LinkText"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../store/hooks"
import { createEmailLoginServiceRequest } from "../../store/features/authSlice"
import { ReactComponent as SmartIDLoginButton } from '../../components/form/Smart-ID_login_btn.svg';
import { DividerWithText } from "../common/DividerWithText"
import { Label } from "./Label"

export interface LoginFormProps {
    handleSmartIdLoginPress: (personalCode: string) => void;
}

export const LoginForm: React.FC<LoginFormProps> = (props) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [smartIDlogin, setSmartIDLogin ] = useState(false);
    const [personalCode, setPersonalCode] = useState("");
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const authState = useAppSelector((state) => state.auth.user);

    useEffect(() => {
        if (authState) {
            navigate("/");
        }
    }, [authState])

    const handleLoginPress = () => {
        if (email.length && password.length) {
            dispatch(createEmailLoginServiceRequest({email, pwd: password}));
        }
    }

    return (
        <div className="w-full lg:w-[400px] space-y-2 h-fit shadow-main px-8 py-7 rounded-xl bg-white">
            <form className="flex flex-col gap-3" onSubmit={(e) => {e.preventDefault()}}>
            <h2>Logi sisse</h2>
            <div>
                <Label value={"Email"}/>
                <Input value={email} onChange={(e) => setEmail(e)} type="email" autoComplete="email" placeHolder="Sisesta email" name="email"></Input>
            </div>
            <div>
                <Label value={"Parool"}/>
                <PasswordInput value={password} onChange={(e) => setPassword(e)} placeHolder="Sisesta parool"></PasswordInput>
                <div className="flex items-start mt-1"><LinkText text="Unustatsin parooli" onClick={() => navigate('/reset-password-email')}/></div>
            </div>
            <div className="flex">
                <div className="flex items-center gap-1"><Checkbox checked={true} onChange={(v) => {}}></Checkbox> Jäta mind meelde</div>
            </div>
            <div className="pt-4">
             <PrimaryButton title='Logi sisse' onClick={() => handleLoginPress()}/>
            <div className="flex items-start mt-2"><LinkText text="Pole veel kontot? Loo konto" onClick={() => navigate('/signup')}/></div>
            </div>
            <div className="my-2">
                <DividerWithText text="Või kasuta" />
            </div>
            <div className="w-full h-[60px] flex flex-col justify-center">
                {
                    smartIDlogin ?
                        <div className="flex flex-row w-full gap-1">
                            <div className="flex-1">
                                <Input value={personalCode} onChange={(e) => setPersonalCode(e)} placeHolder="Sisesta isikukood" name="personalCode"></Input>
                            </div>
                            <div className="flex-none">
                                <PrimaryButton title='Edasi' onClick={() => props.handleSmartIdLoginPress(personalCode)}/>
                            </div>
                        </div>
                    :
                    <SmartIDLoginButton style={{ width: '100%', height: '100%' }} onClick={() => {setSmartIDLogin(true)}} className="cursor-pointer"/>
                }
            </div>
            </form>
        </div>
    )
}